import React from 'react';

import Button from 'components/Button';
import { ICONS_MAP } from 'constants/icons';
import { appReactMemo } from 'hocs';

import { StyledTooltip } from './styled';

export const WIDE_HINT_WIDTH = 420;

export interface IHintButton {
  children: string;
  maxHintWidth?: number;
  startIcon?: React.ReactNode;
}

const HintButton = ({
  children,
  maxHintWidth = 300,
  startIcon = <ICONS_MAP.QuestionMark />,
}: IHintButton) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const showHint = React.useCallback(() => setIsOpen(true), []);
  const hideHint = React.useCallback(() => setIsOpen(false), []);

  return (
    <StyledTooltip
      component={children}
      maxHintWidth={maxHintWidth}
      onClose={hideHint}
      onOpen={showHint}
      open={isOpen}
    >
      <Button
        enableShowFocus
        iconSize={16}
        onBlur={hideHint}
        onClick={showHint}
        onFocus={showHint}
        size='xxs'
        startIcon={startIcon}
        variant='icon'
      />
    </StyledTooltip>
  );
};

export default appReactMemo(HintButton);
